var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPodcast({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66699 11.6667V15.0001V15.8334C1.66699 17.2141 2.78628 18.3334 4.16699 18.3334H5.00033C6.38104 18.3334 7.50033 17.2141 7.50033 15.8334V13.3334C7.50033 11.9527 6.38104 10.8334 5.00033 10.8334H3.33366V10.0001C3.33366 6.31818 6.31843 3.33341 10.0003 3.33341C13.6822 3.33341 16.667 6.31818 16.667 10.0001V10.8334H15.0003C13.6196 10.8334 12.5003 11.9527 12.5003 13.3334V15.8334C12.5003 17.2141 13.6196 18.3334 15.0003 18.3334H15.8337C17.2144 18.3334 18.3337 17.2141 18.3337 15.8334V15.0001V11.6667V10.0001C18.3337 5.39771 14.6027 1.66675 10.0003 1.66675C5.39795 1.66675 1.66699 5.39771 1.66699 10.0001V11.6667ZM15.0003 12.5001H16.667V15.8334C16.667 16.2937 16.2939 16.6667 15.8337 16.6667H15.0003C14.5401 16.6667 14.167 16.2937 14.167 15.8334V13.3334C14.167 12.8732 14.5401 12.5001 15.0003 12.5001ZM3.33366 15.8334V12.5001H5.00033C5.46056 12.5001 5.83366 12.8732 5.83366 13.3334V15.8334C5.83366 16.2937 5.46056 16.6667 5.00033 16.6667H4.16699C3.70675 16.6667 3.33366 16.2937 3.33366 15.8334Z",
    fill: "#162941"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodcast);
export default __webpack_public_path__ + "static/media/podcast.b02d3a59b67de8938443b2cb0bbc3bc9.svg";
export { ForwardRef as ReactComponent };